/* eslint-disable camelcase */
import axios from 'api/axios'
import {
	ClientWallet,
	ClientWalletTransaction,
	clientWalletTransactionData,
} from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getWalletTranstions
 */

export interface GetWalletTransactionParams {
	id: string
	page?: number
	size?: number
	query?: string
	startDate?: string
	endDate?: string
	should_export?: boolean
	type?: 'CREDIT' | 'DEBIT'
}

/**
 * Type Interface for the Response object you get from getWalletTranstions request if successful
 */
export interface GetWalletTransactionResponse {
	transactions: clientWalletTransactionData
	records: ClientWalletTransaction[] | []
	totalCount: number
	totalPages: number
	currentPage: number
	wallet: ClientWallet | null
}

/**
 * API call to get Clients Wallet from the WhatCX Application
 * @param options GetWalletTransactionParams - Options for the API call
 * @returns Wallet Transaction Response - Response object returned from the server
 */

export const getWalletTransactions = async (
	options: GetWalletTransactionParams
) => {
	try {
		const { id, ...params } = options
		const { data } = await axios.get<GetWalletTransactionResponse>(
			`client/${id}/wallet`,
			{
				params,
			}
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getWalletTransactions
